<script setup lang="ts">
/**
 * Entry page for the flow
 * --------------------------------------------------------------------------------------------------
 * This page is SERVER-SIDE-RENDERED and serves as a fast-loaded entry point
 * to the product flow. it resets all stores.
 */
definePageMeta({
    layout: 'empty',
    path: '/booking/guided-tour/start',
    title: 'offerFlow.splashMessage.guided-tour',
});

onMounted(() => {
    useResetStores().resetOfferFlow();
    useStartFreshFlow().startFreshFlow(productConfigGuidedTour);
});
</script>

<template>
    <IntroLoader />
</template>
